
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');
    
    try {
      // Получаем токен reCAPTCHA
      let recaptchaToken = '';
      try {
        if (typeof window !== 'undefined' && (window as any).grecaptcha) {
          recaptchaToken = await (window as any).grecaptcha.execute(
            '6LfjXHspAAAAAJCKf3-ionD9nSmId3ofkdyoPvHP',
            { action: 'submit' }
          );
        }
      } catch (recaptchaError) {
        console.warn('reCAPTCHA error:', recaptchaError);
        // Продолжаем без токена, сервер обработает
      }

      const response = await fetch('/sendmail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
          recaptcha_token: recaptchaToken,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Ошибка сервера' }));
        setErrorMessage(errorData.error || 'Ошибка при отправке формы');
        setSubmitStatus('error');
        return;
      }

      const data = await response.json();

      if (data.success) {
        setSubmitStatus('success');
        setErrorMessage('');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setErrorMessage(data.error || 'Не удалось отправить сообщение');
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setErrorMessage('Ошибка соединения. Проверьте интернет и попробуйте снова.');
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-gray-900 mb-4">
            Готовы начать сотрудничество?
          </h2>
          <p className="text-lg text-gray-600 font-light">
            Бесплатная 30‑минутная консультация, чтобы обсудить задачи и определить план действий.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="Ваше имя"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="w-full px-0 py-3 text-gray-900 placeholder-gray-500 border-0 border-b border-gray-300 focus:border-gray-700 focus:outline-none bg-transparent font-light"
                />
              </div>
              
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="E-mail"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-0 py-3 text-gray-900 placeholder-gray-500 border-0 border-b border-gray-300 focus:border-gray-700 focus:outline-none bg-transparent font-light"
                />
              </div>
              
              <div>
                <textarea
                  name="message"
                  rows={4}
                  placeholder="Расскажите о проекте"
                  value={formData.message}
                  onChange={handleInputChange}
                  maxLength={500}
                  className="w-full px-0 py-3 text-gray-900 placeholder-gray-500 border-0 border-b border-gray-300 focus:border-gray-700 focus:outline-none bg-transparent resize-none font-light"
                />
                <div className="text-right text-xs text-gray-400 mt-1">
                  {formData.message.length}/500
                </div>
              </div>
              
              <div className="pt-4">
                <Button 
                  type="submit" 
                  variant="primary" 
                  size="lg" 
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Отправляем...' : 'Отправить заявку'}
                </Button>
              </div>
              
              {submitStatus === 'success' && (
                <div className="text-green-600 text-sm font-light">
                  Спасибо! Мы свяжемся с вами в течение рабочего дня.
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="text-red-600 text-sm font-light">
                  {errorMessage || 'Не удалось отправить сообщение. Попробуйте снова чуть позже.'}
                </div>
              )}
            </form>
          </div>
          
          <div className="space-y-8">
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-3">Контактная информация</h3>
              <div className="space-y-3 text-gray-600 font-light">
                <p>info@elkostart.ru</p>
                <p>+7 (905) 701-06-31</p>
                <p>108815, Москва, Филимонковское п., Марьино п., Светлый б-р, 13, к. 5, 12</p>
              </div>
            </div>
            
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-3">Режим работы</h3>
              <div className="space-y-2 text-gray-600 font-light">
                <p>Пн–Пт: 09:00 – 19:00 (МСК)</p>
                <p>Сб: 10:00 – 15:00</p>
                <p>Вс: выходной</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
